module.exports = ".pending-payment-text, .cancel-payment-text {\r\n    float: left;\r\n}\r\n\r\n.cancel-payment-text {\r\n    padding-left: 10px;\r\n}"